/**
 *  Re-package Radio (Label as node) that can be used by SaleChannel
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */

import React from 'react';

import { Image, Radio } from 'src/components/Antd';

import css from './SaleChannelRadioItem.less';

const SaleChannelRadioItem = (props) => {
  const { radioList, onChange, value, hideRadio } = props;

  return (
    <div className={css.radioAll}>
      {radioList.map((item) => (
        <div key={item.value} className={css.radioItem}>
          {!hideRadio && (
            <Radio
              radioList={[item]}
              onChange={onChange}
              value={value}
              className={css.radioList}
            />
          )}
          <Image className={css.image} src={item.image}></Image>
          <div className={css.right}>
            <p className={css.title}>{item.title}</p>
            <p className={css.description}>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
export default SaleChannelRadioItem;
